/**
 * 模块 - 路由/菜单 - 中文
 * meta.title 使用英文 key，与 permission.js 中 i18n.t('route.' + rawTitle) 一致
 */
export default {
  route: {
    login: '登录',
    redirecting: '等待跳转',
    exportImport: '导出导入',
    noPermission: '无权限',
    pageNotFound: '页面不存在',
    purchaseOrders: '采购订单',
    transferGoodsManagement: '借调货管理',
    creditOrders: '赊货管理',
    doubleOrders: '双重订单',
    createDoubleOrder: '创建双重订单',
    headOfficeShipment: '总部发货',
    regionalShipmentRecords: '区域发货记录',
    regionalJdWarehouseShipment: '区代京东仓发货',
    cloudWarehouseShipmentDetails: '云仓发货详情',
    accountSettlement: '账户结算单',
    accountAssetDashboard: '账户资产看板',
    maintenanceManagement: '维修管理',
    callCenterConfig: '呼叫中心配置',
    noviceTasks: '新手任务',
    dashboard: '仪表盘',
    analystManagement: '分析员管理',
    accountManagement: '账户管理',
    employeeAccounts: '员工账号',
    tools: '小工具',
    organizationArchive: '组织档案',
    goldAccountManagement: '金账户管理',
    salesShipment: '销售发货',
    potentialCustomers: '潜在客户',
    leadManagement: '线索管理',
    targetManagement: '目标管理',
    dataReports: '数据报表',
    studyMachineManagement: '学习机管理',
    takeDelivery: '仓内提货',
    newLading: '新建提货单',
    ladingDetail: '提货单详情',
    barterManagement: '换货管理',
    teacherChildrenDevice: '教师子女机管理',
    childrenDeviceDetail: '子女机详情',
    supervisorManagement: '督学管理',
    studentManagement: '学生管理',
    addStudentList: '添加学生列表',
    scoreManagement: '成绩管理',
    supervisorData: '督学师数据',
    supervisorDetails: '督学师明细',
    supervisorSummary: '督学师小结',
    dataLibrary: '资料库',
    assignPermissions: '分配权限',
    customQuickIdentity: '自定义快捷身份',
    employeeLearningAccounts: '员工学习账号',
    scoreCollectionTotal: '成绩收集（总）',
    supervisorScoreManagement: '督学师的成绩管理',
    videoCallRecord: '视频通话记录',
    targetSetting: '目标设定',
    performanceReview: '业绩复盘',
    basicSettings: '基础设置'
  }
}
